import { Helmet } from "react-helmet-async";
import { RouteObject } from "react-router-dom";
import AppLayout from "../layout/AppLayout";
import HomePage from "../pages/HomePage";
import VisitePage from "../pages/VisitePage";
import VisitaOtorinolaringoiatricaPage from "../pages/VisitaOtorinolaringoiatricaPage";
import VisitaPediatricaPage from "../pages/VisitaPediatricaPage";
import VisitaAudiologicaPage from "../pages/VisitaAudiologicaPage";
import EsamiPage from "../pages/EsamiPage";
import RinofaringolaringoscopiaPage from "../pages/RinofaringolaringoscopiaPage";
import EsameAudiometricoPage from "../pages/EsameAudiometricoPage";
import ImpedenzometriaPage from "../pages/ImpedenzometriaPage";
import EsameVestibolarePage from "../pages/EsameVestibolarePage";
import ServiziPage from "../pages/ServiziPage";
import CentroConvenzionatoPage from "../pages/CentroConvenzionatoPage";
import ChiSonoPage from "../pages/ChiSonoPage";
import ContattiPage from "../pages/ContattiPage";
import PrivacyPolicyPage from "../pages/PrivacyPolicyPage";
import NotFoundPage from "../pages/NotFoundPage";

type Props = {
  title: string;
  element: React.ReactNode;
};

function Page({ title, element }: Props) {
  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      {element}
    </>
  );
}

export const APP_ROUTES: Array<RouteObject> = [
  {
    path: "/",
    element: <AppLayout />,
    children: [
      {
        index: true,
        element: <Page title="Home" element={<HomePage />} />,
      },
      {
        path: "visite",
        element: <Page title="Visite" element={<VisitePage />} />,
      },
      {
        path: "visite/otorinolaringoiatrica",
        element: <Page title="Visita Otorinolaringoiatrica" element={<VisitaOtorinolaringoiatricaPage />} />,
      },
      {
        path: "visite/pediatrica",
        element: <Page title="Visita Otorinolaringoiatrica Pediatrica" element={<VisitaPediatricaPage />} />,
      },
      {
        path: "visite/audiologica",
        element: <Page title="Visita Audiologica" element={<VisitaAudiologicaPage />} />,
      },
      {
        path: "esami",
        element: <Page title="Esami" element={<EsamiPage />} />,
      },
      {
        path: "esami/rinofaringolaringoscopia",
        element: <Page title="Rinofaringolaringoscopia a Fibre Ottiche" element={<RinofaringolaringoscopiaPage />} />,
      },
      {
        path: "esami/audiometrico",
        element: <Page title="Esame Audiometrico" element={<EsameAudiometricoPage />} />,
      },
      {
        path: "esami/impedenzometria",
        element: <Page title="Impedenzometria" element={<ImpedenzometriaPage />} />,
      },
      {
        path: "esami/vestibolare",
        element: <Page title="Esame Vestibolare" element={<EsameVestibolarePage />} />,
      },
      {
        path: "servizi",
        element: <Page title="Servizi" element={<ServiziPage />} />,
      },
      {
        path: "centro-convenzionato",
        element: <Page title="Centro Convenzionato" element={<CentroConvenzionatoPage />} />,
      },
      {
        path: "chi-siamo",
        element: <Page title="Chi Siamo" element={<ChiSonoPage />} />,
      },
      {
        path: "contatti",
        element: <Page title="Contatti" element={<ContattiPage />} />,
      },
      {
        path: "privacy-policy",
        element: <Page title="Privacy & Cookie Policy" element={<PrivacyPolicyPage />} />,
      },
      {
        path: "*",
        element: <Page title="404 Not Found" element={<NotFoundPage />} />,
      },
    ],
  },
];